export class FileInfo {
  size: number;
  filename: string;
  extension: string;
  isExportfile?: boolean;

  public static equals(x: FileInfo, y: FileInfo) {
    return (
      x &&
      y &&
      x.filename === y.filename &&
      x.size === y.size &&
      x.extension === y.extension &&
      x.isExportfile === y.isExportfile
    );
  }
}
